export default {"src":"/_next/static/media/icone-profile.6d1dce22.svg","height":34,"width":28,"blurWidth":0,"blurHeight":0};